<template>
  <div class="l-row">
    <stock-status :module="module" @change="onChange"/>
  </div>
</template>

<script>
  import StockStatus from '@/components/tool/batch/shared/filters/marketplace/StockStatus'
  import { merge } from 'lodash'

  export default {
    data: () => ({
      filters: null
    }),
    props: {
      module: {
        type: Object,
        required: true
      }
    },
    methods: {
      onChange (filters) {
        this.filters = merge(filters, this.filters)
      }
    },
    components: {
      StockStatus
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Amazon.vue?1a1a67b8